import { useEffect, useState } from "react";
import CookiesCompliance from "./CookiesCompliance";

const LazyCookiesCompliance = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Use the same key CookiesCompliance writes to
    if (localStorage.getItem("cookiePreferences")) return;
    // Don't re-show within the same browser session if the user dismissed with ×
    if (sessionStorage.getItem("nc_ck_dismissed")) return;

    const timer = setTimeout(() => setShow(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return <CookiesCompliance onHide={() => setShow(false)} />;
};

export default LazyCookiesCompliance;
